import { Engine } from '../engine/Engine'
import { CubeTextureLoader, AmbientLight, Box3 } from 'three'
// import { AxesHelper } from 'three'
import { Experience } from '../engine/Experience'
import { Resource } from '../engine/Resources'
import { Position } from './Points'

export class GtlfModel implements Experience {
    resources: Resource[] = []

    constructor(private engine: Engine, building: { path: string, position: Position }) {
        // VR 背景
        const loader = new CubeTextureLoader()
        this.engine.scene.background = loader.load([
            'https://zjbjtech.cn/api/assets/cloud/bff035c8-ad11-4df2-a1f3-7b27af8a1155', 
            'https://zjbjtech.cn/api/assets/cloud/3e05ed44-ca9c-44ab-b2bb-aae5826cd7ed', 
            'https://zjbjtech.cn/api/assets/cloud/d71ec699-c3b7-4f42-aeb5-1d255a80bb7d', 
            'https://zjbjtech.cn/api/assets/cloud/ddae0030-1636-49b9-b6d0-813df1651e27', 
            'https://zjbjtech.cn/api/assets/cloud/bbcb6443-15d0-4085-b834-4771c576e3b5', 
            'https://zjbjtech.cn/api/assets/cloud/05963d3c-e084-40cc-a4a4-9a7081ebf6c4', 
        ])
        this.engine.scene.backgroundIntensity = 0.15
        this.engine.scene.add(new AmbientLight(0xffffff, 0.2))

        building && this.resources.push({
            key: building.path,
            name: building.path,
            type: 'gltf',
            path: building.path,
            position: building.position
        });
    }

    init() {
        // 加载完成后添加到 scene
        const models = this.resources.map((item: Resource) => this.engine.resources.getItem(item.name));
        if (models.length > 0) {

            // models[0].traverse(function (node) {
            //     if (node.isMesh) {
            //         // 设置材质的透明度
            //         node.material.transparent = true;
            //         node.material.opacity = 0.8;
            //     }
            // });

            //  姿态
            models[0].rotation.set(this.resources[0].position?.rx, this.resources[0].position?.ry, this.resources[0].position?.rz)
            models[0].position.set(this.resources[0].position?.px, this.resources[0].position?.py, this.resources[0].position?.pz)
            models[0].scale.set(this.resources[0].position?.sx, this.resources[0].position?.sy, this.resources[0].position?.sz)


            // X 轴：红色（赤色）Y 轴：绿色Z 轴：蓝色
            // this.engine.scene.add(new AxesHelper(20))

            // 获取模型尺寸，调整相机到合适位置
            const bbox = new Box3().setFromObject(models[0]);
            const width = bbox.max.x - bbox.min.x;
            const height = bbox.max.y - bbox.min.y;
            const depth = bbox.max.z - bbox.min.z;
            this.engine.camera.instance.position.z = depth / 2;
            this.engine.camera.instance.position.x = width / 2;
            this.engine.camera.instance.position.y = height / 2;

            this.engine.scene.add(...models);
        }

    }

    resize() { }

    update() { }
}
